import { defineMessages } from 'react-intl';

export default defineMessages({
  messageBoards: 'Message Boards'
});
